import { useQuery } from "@tanstack/react-query";
import {
  getBillsHistory,
  type BillHistory,
} from "../api/reportsBillsHistory";

// Връща затворени сметки, които НЕ са включени в никой отчет — кандидатите
// за фактуриране. Без period filter (1:1 с personal report: показваме всички
// неотчетени, дори от предишни дни). Сортирани са по closed_at desc, така че
// последно затворената е най-отгоре.
//
// Преизползваме `/bills/history` (с `in_report=false`) вместо да правим отделен
// endpoint — същият service слой се грижи за filter/sort/pagination, а нашата
// добавка е само един булев флаг. session_access на BE решава дали закритите
// в брой без бон да се скрият (без код 2) или показват (с код 2 / неархивиран
// ресторант), без да е нужна допълнителна логика тук.
export const useUninvoicedBills = (options?: { enabled?: boolean }) => {
  return useQuery<BillHistory[]>({
    queryKey: ["bills", "uninvoiced"],
    queryFn: async () => {
      const result = await getBillsHistory({
        statuses: ["closed"],
        in_report: false,
        // Скриваме и сметки, които вече са фактурирани (има ред в
        // invoice_bills) — оператор не може да издаде втора фактура за
        // същата сметка.
        in_invoice: false,
        sort_by: "closed_at",
        sort_order: "desc",
        page_size: 200,
      });
      return result.items;
    },
    staleTime: 0,
    refetchOnMount: "always",
    enabled: options?.enabled ?? true,
  });
};
